import React from "react";
import SettingsContainer from "../../../../../components/theme/settings";
import FormGroup from "../../../../../components/theme/form-group/FormGroup";
import UserGroups from "../../../../../components/pickers/user-groups/UserGroups";
import { PropertiesByTrigger } from "./useGeneralSettingsProperties";
import { WorkflowTriggerType } from "../../../../../__generated__/api";
import GeneralDetailsDescription from "./GeneralDetailsDescription";
import ConversationSources from "../../../../../components/pickers/conversation-sources/ConversationSources";

export default function EmojiGeneralDetails({ properties }: { properties: PropertiesByTrigger<WorkflowTriggerType.Emoji> }) {
    return (
        <SettingsContainer navigation="none">
            <SettingsContainer.Section title="General">
                <SettingsContainer.Setting
                    title="Name"
                    description="The name of the emoji automation."
                    permissions={[]}
                >
                    <FormGroup
                        type="text"
                        placeholder="Emoji Automation Name"
                        onChange={evt => properties.name.setValue(evt.target.value)}
                        value={properties.name.value}
                    />
                </SettingsContainer.Setting>
                <SettingsContainer.Setting
                    title="Description"
                    description="The description of the emoji automation."
                    permissions={[]}
                >
                    <GeneralDetailsDescription properties={properties} />
                </SettingsContainer.Setting>

                <SettingsContainer.Setting
                    title="Action Emoji"
                    description="Pick the emoji that will launch the automation when used in a message."
                    permissions={[]}
                >
                    <FormGroup
                        type="text"
                        placeholder="simple_smile"
                        onChange={evt => properties.emoji.setValue(evt.target.value)}
                        value={properties.emoji.value}
                    />
                </SettingsContainer.Setting>

                <SettingsContainer.Setting
                    title="Groups"
                    description="The groups that will be able to use this action."
                    permissions={[]}
                >
                    <UserGroups
                        value={properties.groups.value}
                        onSelected={properties.groups.setValue}
                        isMulti
                        canSelectEveryone
                    />
                </SettingsContainer.Setting>

                <SettingsContainer.Setting
                    title="Channel Groups"
                    description={
                        "Select channel group tags to scope where this emoji automation is active, "
                        + "or leave empty for Global."
                    }
                    permissions={[]}
                >
                    <ConversationSources
                        value={properties.conversationSources.value.map(source => source.value)}
                        onSelected={(ids, names) => properties.conversationSources.setValue(ids.map((id, index) => ({
                            label: names[index],
                            value: id,
                        })))}
                        shouldIncludeTags
                        isMulti
                    />
                </SettingsContainer.Setting>
            </SettingsContainer.Section>
        </SettingsContainer>
    );
}
